<template>
  <!-- ***** Welcome Area Start ***** -->
  <div class="welcome-area" id="welcome">
    <!-- ***** Header Text Start ***** -->
    <div class="header-text">
      <div class="container">
        <div class="row">
          <div
            class="left-text col-lg-6 col-md-12 col-sm-12 col-xs-12"
            data-scroll-reveal="enter left move 30px over 0.6s after 0.4s"
          >
            <h1>
              HONOURING MALAYSIA’S BEST PERFORMERS IN <em>ESG EXCELLENCE</em>
            </h1>
            <!-- <p>Lava <a href="#">HTML landing page</a> template is provided by <a href="#">TemplateMo</a>.
                           You can modify and use it for your commercial websites for free of charge. This template is last updated on 29 Oct 2019.</p>  -->
            <a href="#about" class="main-button-slider">FIND OUT MORE</a>
          </div>
        </div>
      </div>
    </div>
    <!-- ***** Header Text End ***** -->
  </div>
  <!-- ***** Welcome Area End ***** -->
</template>

<script>
export default {};
</script>

<style></style>
